import http from '@/js/Http'
import {AxiosOptions} from 'guaxinim-web'

export default {
  create(entity) {
    const url = `/estado/`
    return new Promise((resolve, reject) => {
      http.post(url, entity).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  edit(id, entity) {
    const url = `/estado/${id}`
    return new Promise((resolve, reject) => {
      http.put(url, entity).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findDTOByID(id) {
    const url = `/estado/dto/${id}`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findDTOs(ids, filterparams) {
    const params = {
      ids,
      filterparams
    }
    const options = {
      ...AxiosOptions,
      params
    }
    const url = `/estado/dto`
    return new Promise((resolve, reject) => {
      http.get(url, options).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findEntities(ids) {
    const params = {
      ids
    }
    const options = {
      ...AxiosOptions,
      params
    }
    const url = `/estado/`
    return new Promise((resolve, reject) => {
      http.get(url, options).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findEntityByID(id) {
    const url = `/estado/${id}`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findEstadoFinderDTO(ids, busca, limite) {
    const params = {
      ids,
      busca,
      limite
    }
    const options = {
      ...AxiosOptions,
      params
    }
    const url = `/estado/finder`
    return new Promise((resolve, reject) => {
      http.get(url, options).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findEstadoFinderDTOByID(id) {
    const url = `/estado/finder/${id}`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  getDtoPresentation() {
    const url = `/estado/dto/presentation`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  getPresentation() {
    const url = `/estado/presentation`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  newEntity() {
    const url = `/estado/new`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  remove(id) {
    const url = `/estado/${id}`
    return new Promise((resolve, reject) => {
      http.delete(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  }
}